import * as React from "react";
import { Card } from 'react-bootstrap';
import './ChooseDetails.css';

export function ChooseDetails(props) {
    return <Card id="PersonalDetails" className={"payment-details-options mb-2 cursor-pointer choose-details"}>
        <Card.Body>
            <Card.Title className="choose-details__title mt-1">
                Which details would you like to view
            </Card.Title>
            <hr className="choose-payment__break" />
            { props.children }
        </Card.Body>
    </Card>
}